import {
  CHARACTERS_REQUEST,
  CHARACTERS_SUCCESS,
  CHARACTERS_FAILED,
} from '../actions/charactersActions';

const initialState = {
  error: false,
  hasMore: true,
  isLoading: false,
  characters: [],
};

export default function charactersReducer(state = initialState, { type, payload }) {
  switch (type) {
    case CHARACTERS_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case CHARACTERS_FAILED:
      return {
        ...state,
        error: payload,
        isLoading: false,
      };
    case CHARACTERS_SUCCESS:
      return {
        characters: [
          ...state.characters,
          ...payload.characters.results
        ],
        nextUrl: payload.characters.info.next,
        isLoading: false,
        hasMore: !!payload.characters.info.next,
      };
    default:
      return state;
  }
}